<template>
    <div>
        <v-server-table ref="equipmentDateTable" url="/equipment/dates/list" :columns="equipmentDateCols" :options="equipmentDateOptions">

            <router-link slot="equipment_id" slot-scope="props" :to="`/equipment/view/${props.row.equipment_id}`" title="View Equipment">
                {{ props.row.equipment_type_name }}
                <span v-if="props.row.equipment_name">-</span> {{ props.row.equipment_name }}
                <span v-if="props.row.model_number">-</span> {{ props.row.model_number }}
                <span v-if="props.row.serial_number">-</span> {{ props.row.serial_number }}
            </router-link>

            <template slot="creator_id" slot-scope="props">
                {{ props.row.FirstName }} {{ props.row.LastName }}
            </template>

            <template slot="date_value" slot-scope="props">
                {{ props.row.date_value | moment("MM/DD/YYYY") }}
            </template>

            <template slot="created_at" slot-scope="props">
                {{ props.row.created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
            </template>

        </v-server-table>
    </div>
</template>

<script>
    export default {
        //props: ['assetType', 'assetId', 'showEquipmentCol'],
        props: {
            assetType: {
                required: false,
                type: String
            },
            assetId: {
                required: false,
                type: Number
            },
            showEquipmentCol: {
                required: false,
                default: true,
            },
        },

        data: function() {
            return {
                userTimezone: this.$store.state.user.timezone,
                exportingTable: false,
                equipmentDateOptions: {
                    uniqueKey: 'equipment_date_id',
                    headings: {
                       // equipment_date_id: 'ID',
                        equipment_id: 'Equipment',
                        creator_id: 'User',
                        date_attribute: 'Date Changed',
                        date_value: 'Date Value',
                        created_at: 'Date Change Was Made',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'equipment_dates.created_at',
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('eqauipmentDateCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Set the Values
                        data.assetType = this.assetType;
                        data.assetId = this.assetId;

                        //Send it
                        return data;
                    },
                },
            }
        },

        computed: {
            equipmentDateCols() {
                //Setup
                var cols = [
                    //'equipment_date_id',
                    //'equipment_id',
                    'creator_id',
                    'date_attribute',
                    'date_value',
                    'created_at',
                ];

                //Check for the show flag
                if(this.showEquipmentCol)
                {
                    var cols = [
                        //'equipment_date_id',
                        'equipment_id',
                        'creator_id',
                        'date_attribute',
                        'date_value',
                        'created_at',
                    ];
                }

                //Send it
                return cols;
            }
        },

        methods: {

            filtersChanged: function (filters) {
                //Set the store
                this.$store.commit('setFilters', {key: 'equipmentFilters', filters: filters});

                //Set the data
                this.$refs.equipmentDateTable.getData();
            },

            filtersCleared: function (filters) {
                this.$store.commit('setFilters', {key: 'equipmentFilters', filters: {
                    'equipment.equipment_type_id': [],
                    'equipment.issue_date' : '',
                    'equipment.calibrate_date' : '',
                    'equipment.return_date' : '',
                    'equipment.purchase_date' : '',
                    'equipment.jobsite_id' : null,
                    'jobsite.DivisionId': [],
                }});

                this.$refs.equipmentDateTable.refresh();
            },

            extractFilters: function(){
                //Setup
                let storeFilters = this.$store.state.tableFilters.equipmentFilters;

                //Get the filters
                let filters = {
                    'equipment.equipment_type_id': [],
                    'equipment.issue_date' : storeFilters['equipment.issue_date'],
                    'equipment.calibrate_date' : storeFilters['equipment.calibrate_date'],
                    'equipment.return_date' : storeFilters['equipment.return_date'],
                    'equipment.purchase_date' : storeFilters['equipment.purchase_date'],
                    'equipment.jobsite_id' : storeFilters['equipment.jobsite_id'],
                    'jobsite.DivisionId': [],
                };

                //Loop and build
                for(var i = 1; i <= storeFilters['equipment.equipment_type_id'].length; i++)
                {
                    //Add each id
                    filters['equipment.equipment_type_id'].push(storeFilters['equipment.equipment_type_id'][(i - 1)]['id']);
                }

                //Loop and Build
                for(var i = 1; i <= storeFilters['jobsite.DivisionId'].length; i++)
                {
                    //Add each id
                    filters['jobsite.DivisionId'].push(storeFilters['jobsite.DivisionId'][(i - 1)]['id']);
                }

                //Send it
                return filters;
            },

            exportDataTable(){
                //Loading indicator
                this.exportingTable = true;

                //Build the payload
                var payload = {
                    filters: this.extractFilters(),
                    query: (this.$refs.equipmentDateTable.getRequestParams()).query,
                    orderBy: this.$refs.equipmentDateTable.options.orderBy.column,
                    ascending: this.$refs.equipmentDateTable.options.orderBy.ascending,
                    table: 'equipmentDateTable',
                    columns: this.$refs.equipmentDateTable.columns,
                };

                //Send it
                this.$http.get('/equipment/dates/list?export=true', payload)
                    .then(response => {
                        //Open the new window
                        window.open(response.data);
                    })
                    .catch(err => {
                        //Alert the user
                        this.$toastr.error(err.response.data, 'Failed to Export Equipment Date List');
                    })
                    .then(response => {
                        //reset
                        this.exportingTable = false;
                    });
            },
        },
    }
</script>
